<template>
  <ag-modal-container
    title="Ajouter une cause de rebut"
    width="600px"
    @close="back"
  >
    <rejection-cause-form
      v-model="value"
      @validate="isValid = $event"
    />

    <template v-slot:footer>
      <v-spacer />
      <v-btn
        :loading="loading"
        :disabled="!isValid"
        color="accent"
        class="ml-5"
        @click="create"
        v-text="'Ajouter'"
      />
      <v-spacer />
    </template>
  </ag-modal-container>
</template>

<script>
import { mapActions } from 'vuex'
import Repositories from 'src/repositories'

import AgModalContainer from 'src/components/common/AgModalContainer'
import RejectionCauseForm from '../components/RejectionCauseForm'

export default {
  name: 'RejectionCauseCreateContainer',
  components: {
    AgModalContainer,
    RejectionCauseForm,
  },
  data: () => ({
    isValid: false,
    loading: false,
    value: {
      name: '',
      partType: null,
    },
  }),
  methods: {
    ...mapActions('ui', {
      showSuccessNotification: 'showSuccessNotification',
      showErrorNotification: 'showErrorNotification',
    }),
    back () {
      this.$router.back()
    },
    async create () {
      this.loading = true
      try {
        await Repositories.rejectionCause.post(this.value)
        this.showSuccessNotification(`La cause de rebut ${this.value.name} a bien été créé`)
        this.back()
      }
      catch (error) {
        this.showErrorNotification(Repositories.parseErrorMessage(error))
      }
      finally {
        this.loading = false
      }
    },
  },
}
</script>
